var render, staticRenderFns
import script from "./App.vue?vue&type=script&lang=tsx&"
export * from "./App.vue?vue&type=script&lang=tsx&"
import style0 from "./App.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports